import styled from 'styled-components';

export const KpiChartConatinerTitleStyled = styled.h3`
  text-transform: capitalize;
  line-height: 17px;
  margin-bottom: 2px;
`;
